export default __webpack_public_path__ + "media/images/logo.toot-cat.3-16f6623cb8426013998a42e738a804f5.svg";